// src/pages/CategoriaAdmin.js

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../Config';

const CategoriaAdmin = () => {
  const [categorias, setCategorias] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/categorias`);
        setCategorias(response.data);
        setCargando(false);
      } catch (err) {
        console.error(err);
        setError('Error al cargar categorías');
        setCargando(false);
      }
    };

    fetchCategorias();
  }, []);

  const manejarAgregar = () => {
    navigate('/registro-categoria');
  };

  const manejarEditar = (id) => {
    navigate(`/editar-categoria/${id}`);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 flex flex-col items-center">
      <div className="bg-white shadow-lg rounded-lg w-full max-w-3xl p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">Listado de Categorías</h2>
          <button
            onClick={manejarAgregar}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            + Agregar Categoría
          </button>
        </div>

        {cargando ? (
          <p className="text-gray-600">Cargando categorías...</p>
        ) : error ? (
          <p className="text-red-600">{error}</p>
        ) : (
          <table className="w-full table-auto border">
            <thead className="bg-gray-200 text-left">
              <tr>
                <th className="p-2 border">ID</th>
                <th className="p-2 border">Nombre</th>
                <th className="p-2 border">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {categorias.map((cat) => (
                <tr key={cat.id} className="hover:bg-gray-100">
                  <td className="p-2 border">{cat.id}</td>
                  <td className="p-2 border">{cat.nombre}</td>
                  <td className="p-2 border">
                    <button
                      onClick={() => manejarEditar(cat.id)}
                      className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                    >
                      Editar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default CategoriaAdmin;
